import script from "./CreateTeamModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateTeamModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateTeamModal.vue?vue&type=style&index=0&id=babb5412&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-babb5412"]])

export default __exports__